import React from 'react';
import { ScoreChip } from '../../pages/network/catalogShared';
import { CvSubscores } from '../../types/consumerVoice';

// Consumer Voice Score pill — the same ScoreChip as PDP scores with a
// CV-specific tooltip (sub-scores when the row carries them).
export function CvScoreChip({
  score,
  subscores,
  title,
}: {
  score: number | null | undefined;
  subscores?: CvSubscores | null;
  title?: string;
}) {
  const parts: string[] = [];
  if (subscores) {
    if (subscores.sentiment != null) parts.push(`Sentiment ${subscores.sentiment}`);
    if (subscores.advocacy != null) parts.push(`Advocacy ${subscores.advocacy}`);
    if (subscores.objection_severity != null) parts.push(`Objection severity ${subscores.objection_severity}`);
  }
  const tip =
    title ||
    `Consumer Voice Score: how consumers feel about this product on Reddit${parts.length ? ` · ${parts.join(' · ')}` : ''}`;
  return <ScoreChip score={score} title={tip} />;
}
